import {  createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { OrganisationExtraReducer } from './organisationThunk';


export interface OrganisationState {
  loadStatus: 'idle' | 'loading' | 'failed' | 'success',
  dataSource: any,
  columns: any,
}

const initialState: OrganisationState = {
  loadStatus: 'loading',
  dataSource: [],
  columns: [],
};


export const organisationSlice = createSlice({
  name: 'organisation',
  initialState,
  reducers: {
    
  },
  extraReducers: OrganisationExtraReducer,
});

// export const { } = organisationSlice.actions;

export const selectloadStatus = (state: RootState) => state.organisation.loadStatus;
export const selectDataSource = (state: RootState) => state.organisation.dataSource;
export const selectColumns = (state: RootState) => state.organisation.columns;

export default organisationSlice.reducer;
